import scrollIntoView from 'scroll-into-view-if-needed';
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed';

export const DEFAULT_SCROLL_OPTIONS = {
  behavior: 'smooth',
  block: 'start',
  scrollMode: 'if-needed',
};

export const scrollIntoViewSmoothly = (node, options = DEFAULT_SCROLL_OPTIONS) => {
  if (!node) return;
  const scrollUtil =
    'scrollBehavior' in document.documentElement.style ? scrollIntoView : smoothScrollIntoView;
  scrollUtil(node, options);
};
